export default "__VITE_ASSET__3ca5097e__"